import Airtable, { Records } from 'airtable';

import { AirTable } from '@/models/air-table.model';

const airtable = new Airtable({
  apiKey: process.env.VUE_APP_AIRTABLE_API_KEY
});

export const GetAllFromTable = <T = AirTable>(base: string, table: string): Promise<Records<T>> =>
  airtable
    .base(base)(table)
    .select()
    .all() as Promise<Records<T>>;
